window.XLSX = require('xlsx');
window._ = require('lodash')
window.XLSXReader = require("./xlsx-reader.js");


//////////////////
// WEBPACK FOOTER
// ./assets/js/xlsx-init.js
// module id = 382
// module chunks = 0